<div class="p-2">
    <formly-form [form]="form" [fields]="fields()" [model]="componentModel"></formly-form>
    <button mat-button color="warn" (click)="resetCheckboxes()">
        {{ _translocoContent()['grid.reset'] }}
    </button>
</div>
